import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import styles from 'modules/timeoff/components/Leaves/Overview/index.module.scss'

const StatRowSkeleton = () => (
  <Box
    gap="s32"
    flexDirection="row"
    alignItems="center"
    justifyContent="center"
    paddingTop="s32"
    paddingBottom="s24"
    height="s96"
  >
    <StatColumnSkeleton />
    <StatColumnSkeleton />
    <StatColumnSkeleton />
  </Box>
)

const StatColumnSkeleton = () => (
  <Box gap="s4" justifyContent="center" alignItems="center">
    <Skeleton height="s32" width="s32" />
    <Skeleton height="s16" width="s96" />
  </Box>
)

const SkeletonLoader = () => {
  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      gap="s16"
      paddingX="s4"
    >
      <Box height="s32" style={{ width: '28px' }} /> {/* arrow placeholder to preserve the width */}
      <Box
        flexDirection="column"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        padding="s2"
        background="grey200"
        width="full"
        justifyContent="spaceBetween"
      >
        <Box
          border={{
            bottom: {
              color: 'grey400',
              width: 's1',
              style: 'solid',
            },
          }}
          justifyContent="center"
        >
          <div className={styles.container}>
            <Box
              textAlign="center"
              paddingY="s8"
              width="s240"
              alignItems="center"
              gap="s4"
              alignSelf="center"
              style={{
                margin: 'auto',
                height: '56px',
              }}
            >
              <Skeleton height="s16" width="s140" />
              <Skeleton height="s16" width="s240" />
            </Box>
          </div>
        </Box>
        <StatRowSkeleton />
      </Box>
      <Box height="s32" style={{ width: '28px' }} /> {/* arrow placeholder to preserve the width */}
    </Box>
  )
}

export default SkeletonLoader
